module.exports = __webpack_public_path__ + "static/img/mask3.cad2aeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mask3.png
// module id = lodb
// module chunks = 0